import {useQuery} from '@tanstack/react-query';

import {fetchTrendingPlaylistsData} from '@/api/trendingPlaylists';
import {QueryKeys} from '@/types/queryKeys';

export const useTrendingPlaylistsQuery = () => {
  const query = useQuery({
    queryKey: [QueryKeys.trendingPlaylists],
    queryFn: fetchTrendingPlaylistsData,
  });

  return {
    trendingPlaylists: query.data || [],
    query,
  };
};
